<template>
  <!--
      作者：luoyiming
      时间：2019-10-24
      描述：支付宝推广人列表
  -->
  <div class="product-list">
    <div>
      <el-button size="mini">发送函件通知</el-button>
      <el-button size="mini" @click="collectionSMS()">发送催收短信</el-button>
      <el-button size="mini" @click="collectionPhone()">录入电话催记</el-button>
      <el-button size="mini" @click="Repayment()">生成还款码</el-button>
      <el-button size="mini">请求更新还款细明</el-button>
    </div>
    <div
      v-if="tableData1.length > 0 || tableData2.length > 0"
      style="margin-top: 5vh;"
    >
      <div class="common-form">短信催收记录</div>
      <el-table
        ref="multipleTable"
        :data="tableData1"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="index" label="序列" width="50">
        </el-table-column>
        <el-table-column prop="auth_name" label="发送人"> </el-table-column>
        <el-table-column prop="phone" label="催收手机号"> </el-table-column>
        <el-table-column prop="send_content" label="催收内容">
        </el-table-column>
        <el-table-column prop="create_time" label="发送时间"> </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          background
          :current-page="curPage1"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, prev,sizes ,pager, next, jumper"
          :total="totalDataNumber1"
        ></el-pagination>
      </div>
      <div class="common-form">电话催收记录</div>
      <el-table
        ref="multipleTable"
        :data="tableData2"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="index" label="序列" width="50">
        </el-table-column>
        <el-table-column label="是否接听">
          <template slot-scope="scope">
            <div>{{ getStatusText(scope.row.call_status) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="发送时间"> </el-table-column>
        <el-table-column prop="description" label="记录内容"> </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          background
          :current-page="curPage2"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, prev,sizes ,pager, next, jumper"
          :total="totalDataNumber2"
        ></el-pagination>
      </div>
    </div>
    <div
      v-else
      class="d-c-c d-c"
      style="min-height: 100px;text-align:center;white-space:pre;margin-top: 10vh;"
    >
      <i class="icon-null"> </i>
      你目前还未进行任何催收操作，请尽快处理
      当你产生第一条催收记录时，改案件会自动移入“跟进中”事件
    </div>
    <div>
      <el-dialog class="QrPayModel" :visible.sync="showVisible1" width="800px">
        <iframe
          :srcdoc="innerHTMLs"
          frameborder="no"
          border="0"
          marginwidth="100px"
          marginheight="100px"
          scrolling="no"
          width="750"
          height="600"
          style="overflow:hidden;"
        >
        </iframe>
      </el-dialog>
    </div>
    <div>
      <el-dialog
        title="添加采购记录"
        :visible.sync="dialogFormVisible"
        class="dialogBox"
        :destroy-on-close="true"
        :before-close="handleClose"
      >
        <el-form
          :model="addUserData"
          label-width="100px"
          ref="addUserData"
          :rules="rules"
        >
          <el-form-item label="拨打状态" prop="call_status">
            <el-radio-group v-model="addUserData.call_status">
              <el-radio :label="1">已接听</el-radio>
              <el-radio :label="2">未接听</el-radio>
              <el-radio :label="3">挂断</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="记录内容" prop="content">
            <el-input
              v-model="addUserData.content"
              placeholder="请填写记录内容"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="queding">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import CollectionApi from "@/api/collection.js";

export default {
  props: ["caseId"],

  components: {},
  data() {
    return {
      showVisible1: false,
      innerHTMLs: "",
      dialogFormVisible: false,
      tableData2: [],
      tableData1: [],
      addUserData: {
        due_id: "",
        call_status: 1,
        content: ""
      },
      rules: {
        call_status: [{ required: true, message: "请填写拨打状态!" }],
        content: [{ required: true, message: "请填写记录内容!" }]
      },
      /*一页多少条*/
      pageSize1: 10,
      /*一共多少条数据*/
      totalDataNumber1: 0,
      /*当前是第几页*/
      curPage1: 1,
      /*一页多少条*/
      pageSize2: 10,
      /*一共多少条数据*/
      totalDataNumber2: 0,
      /*当前是第几页*/
      curPage2: 1
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getStatusText(row) {
      const statusMap = {
        1: "已接听",
        2: "未接听",
        3: "挂断"
      };
      // const status = this.detail.hc_contract_status;
      return statusMap[row] || "未知状态";
    },
    /*选择第几页*/
    handleCurrentChange1(val) {
      let self = this;
      self.curPage1 = val;
      self.loading = true;
      self.smsLog();
    },

    /*每页多少条*/
    handleSizeChange1(val) {
      this.curPage1 = 1;
      this.pageSize1 = val;
      self.loading = true;
      this.smsLog();
    },
    /*选择第几页*/
    handleCurrentChange2(val) {
      let self = this;
      self.curPage2 = val;
      self.loading = true;
      self.phoneLog();
    },

    /*每页多少条*/
    handleSizeChange2(val) {
      this.curPage2 = 1;
      this.pageSize2 = val;
      self.loading = true;
      this.phoneLog();
    },
    phoneLog() {
      let Params = {
        due_id: this.$route.query.id,
        page: this.curPage2, // 多少条
        list_rows: this.pageSize2 // 第几页
      };
      this.loading = true;
      CollectionApi.phoneLog(Params, true).then(res => {
        this.loading = false;
        this.tableData2 = res.data.list.data;
        console.log(this.tableData2, "this.tableData2");
        this.totalDataNumber2 = res.data.list.total;
      });
    },
    smsLog() {
      let Params = {
        due_id: this.$route.query.id,
        page: this.curPage1, // 多少条
        list_rows: this.pageSize1 // 第几页
      };
      this.loading = true;
      CollectionApi.smsLog(Params, true).then(res => {
        this.loading = false;
        this.tableData1 = res.data.list.data;
        console.log(this.tableData1, "tableData1");
        this.totalDataNumber1 = res.data.list.total;
      });
    },
    /*获取数据*/
    getData() {
      console.log("获取数据");
      this.phoneLog();
      this.smsLog();
    },
    queding() {
      this.$refs.addUserData.validate(valid => {
        if (!valid) return;
        this.addUserData.due_id = this.$route.query.id;
        CollectionApi.addPhoneLog(this.addUserData, true).then(res => {
          this.dialogFormVisible = false;
          this.addUserData.call_status = 1;
          this.addUserData.content = "";
          this.getData();
          this.$message({
            type: "success",
            message: "添加成功"
          });
        });
      });
    },
    // 弹窗关闭
    handleClose() {
      this.addUserData.content = "";
      this.dialogFormVisible = false;
    },
    collectionPhone() {
      this.dialogFormVisible = true;
    },
    Repayment() {
      let self = this;
      self
        .$confirm("是否要生成还款码?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          CollectionApi.repayMent({ due_id: self.caseId }, true)
            .then(data => {
              self.$message.success("生成成功");
              self.showVisible1 = true;
              self.innerHTMLs = data.data;
              this.$nextTick(() => {
                let formId = document.getElementById("alipaysubmit");
                console.log(formId, "formid");
                // formId.submit()
              });
            })
            .catch(error => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消操作"
          });
        });
    },
    collectionSMS() {
      let self = this;
      self
        .$confirm("是否要发送催收短信?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          CollectionApi.sendSms({ due_id: self.caseId }, true)
            .then(data => {
              this.$message.success("发送成功");
              this.getData();
            })
            .catch(error => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消操作"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.dialogBox {
  width: 100%;
}
.dhx__nav {
  flex-wrap: wrap;
}
.dhx__grid_line {
  width: 100%;
  margin: 20px 0;
  border-top: solid 1px #eee;
}
.dhx__nav-btn {
  margin-left: 0;
  margin-right: 10px;
}
.icon-null {
  height: 7rem;
  aspect-ratio: 1/1;
  color: var(--theme-font-color);
  background-image: url(../../../../assets/icons/null.svg);
  background-repeat: no-repeat;
  background-size: contain;
}
.mb5 {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/collection/manage/sectionRight/test.vue